// import { themeConfig } from './theme-config';

// ----------------------------------------------------------------------

export function createClasses(className: string): string {
  return `boosty__${className}`;
  // return `${themeConfig.classesPrefix}__${className}`;
}
